import { Link, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { NotificationBell } from '../components/notifications/NotificationBell';

export const SupportLayout = () => {
  const { logout, user } = useAuth();
  return (
    <div className="foundation-shell">
      <aside className="fixed inset-y-0 left-0 w-64 bg-[#0b1838] p-6 text-white">
        <Link to="/support/dashboard" className="text-xl font-black">AeroBott Support</Link>
        <nav className="mt-8 grid gap-3 text-sm font-bold">
          <Link to="/support/dashboard">Dashboard</Link>
        </nav>
        {user ? (
          <button onClick={() => void logout()} className="mt-8 rounded-xl bg-[#FF9933] px-3 py-2 text-sm font-black text-slate-950">
            Log out
          </button>
        ) : null}
      </aside>
      <main className="ml-64 min-h-screen">
        <header className="flex items-center justify-end gap-3 border-b border-slate-200 bg-white px-8 py-3">
          <NotificationBell />
        </header>
        <div className="p-8"><Outlet /></div>
      </main>
    </div>
  );
};
